import type { PlanEntitlementsRow } from '../feature-flags/domain/planEntitlements';

/** Nombre del negocio/cuenta para chrome de navegación (sidebar, hub Más). */
export function getOrganizationDisplayName(
  entitlements: PlanEntitlementsRow | null | undefined
): string | null {
  const raw = entitlements?.organization_name;
  if (typeof raw !== 'string') return null;
  const trimmed = raw.trim();
  return trimmed.length > 0 ? trimmed : null;
}
